import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import CartDrawer from "@/components/CartDrawer";
import Footer from "@/sections/Footer";
import { Eyebrow, MaskedLine, Reveal } from "@/components/Reveal";

const POSTS = [
  {
    to: "/blog/affirmations-for-children",
    testid: "blog-card-affirmations",
    img: "/images/affirm-poster-preview.webp",
    tag: "Free printable inside",
    title: "Affirmations for Children",
    excerpt: "The words children hear about themselves soon become the words they use about themselves. Here's a simple, fun way to fill that space with kinder words — plus a free printable “I am” sheet.",
    date: "Oct 7, 2026",
  },
];

export default function BlogPage() {
  return (
    <div className="grain">
      <Navbar />
      <main className="pt-28 sm:pt-32 pb-24 overflow-x-clip">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <Eyebrow className="mb-5">Learn with Bailey</Eyebrow>
            <h1 className="font-display font-extrabold tracking-tight leading-[1.08] text-4xl sm:text-5xl lg:text-6xl text-walnut">
              <MaskedLine i={0}>The Bailey</MaskedLine>
              <MaskedLine i={1} className="text-terracotta">Blog</MaskedLine>
            </h1>
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.55, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 text-base sm:text-lg text-walnutsoft"
            >
              Ideas, activities and free printables for little readers and their grown-ups.
            </motion.p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto">
            {POSTS.map((p, i) => (
              <Reveal key={p.to} delay={i * 0.1}>
                <Link to={p.to} data-testid={p.testid} className="group block h-full">
                  <article className="h-full bg-white/75 border-2 border-sand rounded-[2rem] overflow-hidden shadow-[0_20px_40px_-20px_rgba(49,67,92,0.25)] group-hover:-translate-y-2 group-hover:shadow-[0_30px_50px_-20px_rgba(49,67,92,0.35)] transition-all duration-300">
                    <div className="h-56 sm:h-64 overflow-hidden bg-creamdark/50">
                      <img
                        src={p.img}
                        alt={p.title}
                        className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-6 sm:p-7">
                      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-amberbrand mb-2">{p.tag}</p>
                      <h2 className="font-display font-extrabold tracking-tight text-xl sm:text-2xl text-walnut">{p.title}</h2>
                      <p className="mt-2 text-sm text-walnutsoft leading-relaxed">{p.excerpt}</p>
                      <p className="mt-5 flex items-center justify-between text-sm">
                        <span className="text-walnutmuted">{p.date}</span>
                        <span className="inline-flex items-center gap-1.5 font-display font-bold text-terracotta group-hover:gap-3 transition-all">
                          Read <ArrowRight size={15} />
                        </span>
                      </p>
                    </div>
                  </article>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
